
var _settings = {
  requestForm: {
    get dbId() {
      return this._dbId;
    },
    set dbId(value) {
      localStorage.setItem('requestForm.dbId', value);
      this._dbId = value;
    },

    get pullInit() {
      return this._pullInit;
    },
    set pullInit(value) {
      localStorage.setItem('requestForm.pullInit', value);
      this._pullInit = value;
    },

    _dbId: -1,
    _pullInit: false,
  },
  studentList: {
    get numPerPage() {
      return this._numPerPage
    },
    set numPerPage(value) {
      localStorage.setItem('studentList.numPerPage', value)
      this._numPerPage = value
    },

    get currentPage() {
      return this._currentPage
    },
    set currentPage(value) {
      localStorage.setItem('studentList.currentPage', value)
      this._currentPage = value
    },

    _currentPage: 0,
    _numPerPage: 50,
  },
  routeList: {
    get numPerPage() {
      return this._numPerPage
    },
    set numPerPage(value) {
      localStorage.setItem('routeList.numPerPage', value)
      this._numPerPage = value
    },

    get currentPage() {
      return this._currentPage
    },
    set currentPage(value) {
      localStorage.setItem('routeList.currentPage', value)
      this._currentPage = value
    },

    _currentPage: 0,
    _numPerPage: 50,
  },
  oneTimeNoRideList: {
    get numPerPage() {
      return this._numPerPage
    },
    set numPerPage(value) {
      localStorage.setItem('oneTimeNoRideList.numPerPage', value)
      this._numPerPage = value
    },

    get currentPage() {
      return this._currentPage
    },
    set currentPage(value) {
      localStorage.setItem('oneTimeNoRideList.currentPage', value)
      this._currentPage = value
    },

    _currentPage: 0,
    _numPerPage: 500,
  },
  oneTimeRideList: {
    get numPerPage() {
      return this._numPerPage
    },
    set numPerPage(value) {
      localStorage.setItem('oneTimeRideList.numPerPage', value)
      this._numPerPage = value
    },

    get currentPage() {
      return this._currentPage
    },
    set currentPage(value) {
      localStorage.setItem('oneTimeRideList.currentPage', value)
      this._currentPage = value
    },

    _currentPage: 0,
    _numPerPage: 500,
  },
  dailyNoShowList: {
    get numPerPage() {
      return this._numPerPage
    },
    set numPerPage(value) {
      localStorage.setItem('dailyNoShowList.numPerPage', value)
      this._numPerPage = value
    },

    get currentPage() {
      return this._currentPage
    },
    set currentPage(value) {
      localStorage.setItem('dailyNoShowList.currentPage', value)
      this._currentPage = value
    },

    _currentPage: 0,
    _numPerPage: 500,
  },
  driverList: {
    get numPerPage() {
      return this._numPerPage
    },
    set numPerPage(value) {
      localStorage.setItem('driverList.numPerPage', value)
      this._numPerPage = value
    },

    get currentPage() {
      return this._currentPage
    },
    set currentPage(value) {
      localStorage.setItem('driverList.currentPage', value)
      this._currentPage = value
    },

    _currentPage: 0,
    _numPerPage: 500,
  },
  vehicleList: {
    get numPerPage() {
      return this._numPerPage
    },
    set numPerPage(value) {
      localStorage.setItem('vehicleList.numPerPage', value)
      this._numPerPage = value
    },

    get currentPage() {
      return this._currentPage
    },
    set currentPage(value) {
      localStorage.setItem('vehicleList.currentPage', value)
      this._currentPage = value
    },

    _currentPage: 0,
    _numPerPage: 500,
  },
}

function init() {
  var curr = undefined

  if ((curr = localStorage.getItem('studentList.numPerPage'))) {
    _settings.studentList.numPerPage = parseInt(curr)
  }
  if ((curr = localStorage.getItem('studentList.currentPage'))) {
    _settings.studentList.currentPage = parseInt(curr)
  }

  if ((curr = localStorage.getItem('routeList.numPerPage'))) {
    _settings.routeList.numPerPage = parseInt(curr)
  }
  if ((curr = localStorage.getItem('routeList.currentPage'))) {
    _settings.routeList.currentPage = parseInt(curr)
  }

  if ((curr = localStorage.getItem('driverList.numPerPage'))) {
    _settings.driverList.numPerPage = parseInt(curr)
  }
  if ((curr = localStorage.getItem('driverList.currentPage'))) {
    _settings.driverList.currentPage = parseInt(curr)
  }

  if ((curr = localStorage.getItem('vehicleList.numPerPage'))) {
    _settings.vehicleList.numPerPage = parseInt(curr)
  }
  if ((curr = localStorage.getItem('vehicleList.currentPage'))) {
    _settings.vehicleList.currentPage = parseInt(curr)
  }

  if ((curr = localStorage.getItem('oneTimeNoRideList.numPerPage'))) {
    _settings.oneTimeNoRideList.numPerPage = parseInt(curr)
  }
  if ((curr = localStorage.getItem('oneTimeNoRideList.currentPage'))) {
    _settings.oneTimeNoRideList.currentPage = parseInt(curr)
  }

  if ((curr = localStorage.getItem('oneTimeRideList.numPerPage'))) {
    _settings.oneTimeRideList.numPerPage = parseInt(curr)
  }
  if ((curr = localStorage.getItem('oneTimeRideList.currentPage'))) {
    _settings.oneTimeRideList.currentPage = parseInt(curr)
  }

  if ((curr = localStorage.getItem('dailyNoShowList.numPerPage'))) {
    _settings.dailyNoShowList.numPerPage = parseInt(curr)
  }
  if ((curr = localStorage.getItem('dailyNoShowList.currentPage'))) {
    _settings.dailyNoShowList.currentPage = parseInt(curr)
  }

  if ((curr = localStorage.getItem('requestForm.dbId'))) {
    _settings.requestForm.dbId = parseInt(curr)
  }
  if ((curr = localStorage.getItem('requestForm.pullInit'))) {
    _settings.requestForm.pullInit = (curr === 'true')
  }
}

init()

var studentList = _settings.studentList
var routeList = _settings.routeList
var driverList = _settings.driverList
var vehicleList = _settings.vehicleList
var oneTimeNoRideList = _settings.oneTimeNoRideList
var oneTimeRideList = _settings.oneTimeRideList
var dailyNoShowList = _settings.dailyNoShowList
var requestForm = _settings.requestForm

export default {
  studentList,
  routeList,
  driverList,
  vehicleList,
  oneTimeNoRideList,
  oneTimeRideList,
  dailyNoShowList,
  requestForm,
}
